<template>
    <div class="accordion-list">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'AccordionList',
    provide() {
        return {
            accordionState: this.accordionState
        };
    },
    props: {
        inititalState: {
            type: Object,
            default: () => ({
                activeItem: null
            })
        }
    },
    data() {
        return {
            accordionState: { ...this.inititalState }
        };
    }
};
</script>
